const environment = (href = location.href) =>{
    const staticPath = {
        local: '',
        opdev: ' http://ui-static.korea.ncsoft.corp',
        //opdev: 'https://op-wstatic.ncsoft.com',
        rc: 'https://rc-wstatic.plaync.co.kr',
        live: 'https://wstatic-cdn.plaync.com'
    };
    let here;
    if(/rc\./i.test(href) || /rc-/i.test(href)) {
        here = 'rc';
    }
    else if(/localhost/i.test(href)) {
        here = 'local';
    }
    else if(/local|opdev|ui-static|file:/i.test(href)) {
        here = 'opdev';
    }
    else {
        here = 'live';
    }
    return staticPath[here];
};

export default environment;